var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-106.698 -229.89)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M116.584,229.89h1.23a1.407,1.407,0,0,0,.178.035,9.484,9.484,0,0,1,3.1.719,10.373,10.373,0,0,1,6.448,7.958c.076.386.109.781.162,1.172V241a1.4,1.4,0,0,0-.035.177,9.718,9.718,0,0,1-1.2,4.136,10.309,10.309,0,0,1-8.824,5.554,9.617,9.617,0,0,1-5.345-1.209,10.29,10.29,0,0,1-5.576-8.83,9.731,9.731,0,0,1,1.215-5.365,10.344,10.344,0,0,1,7.437-5.411C115.77,229.979,116.179,229.944,116.584,229.89Zm-1.64,13.24a2.457,2.457,0,0,0-.173-.228q-1.1-1.1-2.2-2.2a1.438,1.438,0,0,0-.2-.177.745.745,0,0,0-1.174.653.857.857,0,0,0,.307.581q1.4,1.4,2.8,2.8a.784.784,0,0,0,1.288.005l7.274-7.274a1.443,1.443,0,0,0,.19-.214.708.708,0,0,0,.03-.792.717.717,0,0,0-.682-.372.87.87,0,0,0-.6.316q-3.331,3.334-6.664,6.667C115.083,242.945,115.037,243.015,114.944,243.13Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.3fe5d9e74e7502eb05f49c323bbb4ccd.svg";
export { ForwardRef as ReactComponent };